﻿import React, { useState, useEffect } from 'react';
import { CrudFunctions } from '../utilities/crud-functions';
import { Decimal4Format } from '../templates/pw-formatting';
import ProductionBenchSheetSolventsComponent from './ProductionBenchSheetSolventsComponent';
import { CalculatedComponentActual } from '../models/calculated-component-actual';
import { DataTemplates } from '../templates/data-templates';
import { PWDates } from '../utilities/pw-dates';
import { Asset } from '../models/asset';
import { UserDataStore } from '../store/userDataStore';
import GlobalDialog from './Modal/GlobalDialog';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';

import DataGrid, {
    Column,
    Paging,
    Toolbar,
    Summary,
    TotalItem,
    Item as ToolbarItem,
    LoadPanel
} from 'devextreme-react/data-grid';

import { Button } from 'devextreme-react/button';
import { Popup as DialogPopup } from 'devextreme-react/popup';

const decimalFormat = {
    type: "fixedPoint",
    precision: 4
}

let key = 1;

export interface Props {
    batchId: string;
    balances?: Asset[];
    isReadOnly: boolean;
    matrixWeight?: number;
}

export default function ProductionBenchSheetSolventsDataComponent(props: Props) {
    const [solvents, setSolvents] =
        useState<CalculatedComponentActual[]>();
        
    const [matrixEditorVisible, setMatrixEditorVisible] =
        useState<boolean>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>();

    useEffect(() => {
        getAllData();
    }, [props.batchId]);

    useEffect(() => {
        updateMatrixWeight();
    }, [props.matrixWeight]);


    const user = UserDataStore.getCurrentUser();
    const canEditRoles = ["SA", "QCBS-A", "QCBS-L", "QCBS-T"];
    const canEdit = canEditRoles.some(r => user.roleCodes && user.roleCodes.includes(r));

    return (
        <div>
            <div>
                <DataGrid id="ProductionBenchSheetSolventsDataGrid"
                    height="12rem"
                    wordWrapEnabled={true}
                    dataSource={solvents ? solvents : []}
                    rowAlternationEnabled={true}
                    showBorders={true}
                    allowColumnResizing={true}
                    showRowLines={true}
                    columnResizingMode='nextColumn'>

                    <LoadPanel enabled={true} />
                    <Paging enabled={false} />

                    <Column dataField='solventRatio' dataType="number" allowEditing={false}
                        width='5rem' alignment='center' cssClass="table-vertical-align" />

                    <Column dataField='partNumber' caption="Part#" dataType="string"
                        allowEditing={false} width='10rem' cssClass="table-vertical-align" />
                    {/*cellRender={solventRawMaterialRender}*/}

                    <Column dataField='vendorPartNumber' dataType="string" caption="Vendor Part#"
                        allowEditing={false} width='10rem' cssClass="table-vertical-align" />

                    <Column dataField='productBatchPartNumber' caption="Aurum Lot Part#" dataType="string" width='10rem'
                         cssClass="table-vertical-align" />
                    {/*cellRender={solventLotFieldRender}*/}

                    <Column dataField='productBatchVendorPartNumber' caption="Vendor Lot#" dataType="string" width='10rem'
                        cssClass="table-vertical-align" />

                    {/*
                    <Column dataField='purity' dataType="number" allowEditing={false}
                        format={decimalFormat} width='6rem' cssClass="table-vertical-align" />

                    <Column dataField='balanceId' width='8rem'
                        cellRender={DataTemplates.BalanceItemRenderById} cssClass="table-vertical-align" />

                    <Column dataField='weight' caption="Weight(mg)" dataType="number"
                        format={decimalFormat} width='6rem' cssClass="table-vertical-align" />
                        */}

                    <Column />

                    <Summary>
                        <TotalItem column="weight" summaryType="sum" valueFormat={Decimal4Format} />
                    </Summary>

                    <Toolbar>
                        <ToolbarItem location='before'>
                            <div className="pw-datagrid-toolbar-template">
                                <div className="pw-datagrid-toobar-title">Matrix</div>
                            </div>
                        </ToolbarItem>
                        {canEdit &&
                            <ToolbarItem location="after">
                                <Button hint="Edit" icon="inserttable"
                                    width="1.8rem" onClick={showMatrixEditor} />
                            </ToolbarItem>
                        }
                    </Toolbar>

                </DataGrid>

            </div>

            {matrixEditorVisible &&
                <DialogPopup visible={matrixEditorVisible}
                    onHiding={hideMatrixEditor}
                    shadingColor="#aaaaaa99"
                    title="Matrix"
                    showCloseButton={false}
                    hideOnOutsideClick={false}
                    fullScreen={true}
                    width="80vw"
                    height="80vh">
                    <ProductionBenchSheetSolventsComponent key={`SS${key}`}
                        isReadOnly={props.isReadOnly}
                        balances={props.balances}
                        batchId={props.batchId}
                        onClose={onMatrixEditorComponentClose} />
                </DialogPopup>
            }

            {globalDialogVisible &&
                <GlobalDialog metadata={globalDialogMetadata} onClose={clearGlobalDialog} />
            }
        </div>
    );

    function updateMatrixWeight() {

        console.log("MAT: updateMatrixWeight");
        console.log(props.matrixWeight);

        if (solvents) {
            let editedSolvents = [...solvents];

            if (editedSolvents.length === 1) {
                editedSolvents[0].weight = props.matrixWeight;
            }
            else if (solvents.length > 1) {
                for (let solvent of editedSolvents) {
                    solvent.weight = (props.matrixWeight * (solvent.solventRatio ? solvent.solventRatio : 0))
                }
            }

            setSolvents(editedSolvents);
        }
    }

    function onMatrixEditorComponentClose() {
        hideMatrixEditor();
        getSolvents();
    }

    async function getSolvents() {
        await CrudFunctions.getData(`products/solvents/${props.batchId}`)
            .then(data => {
                setSolvents(data);
            })
            .catch((res) => {
                showMessage(res, ModalMessageType.Error, "Error Retrieving Solvents");
            });
    }

    async function getAllData() {
        await getSolvents();
    }

    function showMatrixEditor() {
        setMatrixEditorVisible(true);
    }

    function hideMatrixEditor() {
        setMatrixEditorVisible(false);
    }

    //render

    function solventRawMaterialRender(e: any) {
        if (e.data && e.data.rawMaterialName) {
            return (
                <div>
                    <div className="item-main">{e.data.rawMaterialName}</div>
                    <div className="item-sub">{e.data.rawMaterialDescription}</div>
                </div>
            );
        }
        else
            return (<div></div>);
    }

    function solventLotFieldRender(e: any) {
        if (e.data && e.data.rawMaterialBatchName) {
            if (e.data.latestUpdate) {
                if (PWDates.isPreviousDateMoreRecentThanDays(e.data.latestUpdate, 7)) {
                    return (<div className="date-expired">{e.data.rawMaterialBatchName}</div>);

                }
                else if (PWDates.isPreviousDateMoreRecentThanDays(e.data.latestUpdate, 30)) {
                    return (<div className="date-warning">{e.data.rawMaterialBatchName}</div>);
                }
                else
                    return (<div>{e.data.rawMaterialBatchName}</div>);
            }
            else
                return (<div>{e.data.rawMaterialBatchName}</div>);
        }
        else {
            return (<div></div>);
        }
    }

    function showMessage(res: any, mode: ModalMessageType, title: string) {
        let mm: ModalMetadata = {
            error: res,
            mode: mode,
            title: title
        };

        setGlobalDialogMetadata(mm);
        setGlobalDialogVisible(true);
    }

    function clearGlobalDialog() {
        setGlobalDialogMetadata(null);
        setGlobalDialogVisible(false);
    }

}